export default __webpack_public_path__ + "static/media/brgy_logo3.32c0b07c.png";